<template>
    <button v-on:click="remove" :disabled="asSend" class="flex text-white bg-[#f56565] items-center justify-center gap-x-3 rounded-lg py-2 px-3">
        <Trash2 v-if="!asSend" :size="16" strokeWidth="1.3"/>
        <Loader2 v-else :size="16" strokeWidth="1.3" class="animate-spin"/>
        <span>Supprimer</span>
    </button>
</template>
<script>
import {Loader2,Trash2} from "lucide-vue-next"
import API from '@/service/API';
import Swal from 'sweetalert2';
export default {
    name: "RemoveZone",
    props:['id'],
    components: {
        Loader2,
        Trash2
    },
    data(){
        return {
            asSend: false,
        }
    },
    methods:{
        remove(){
            this.asSend = true;
            API.post("removeZone/"+this.id)
            .then((res)=>{
                if(!res.data.status) throw Error(res.data.message)
                Swal.fire('Succès!!!!',"Zone supprimé",'succes')
                this.$emit('child-action');
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=> this.asSend = false)
        }
    }
}
</script>